@if (!maxMode()) {
  <div class="app">
    <div class="navigation">
      <div class="first">
        <img src="/assets/images/app-logo.svg" alt="" />
        <div class="horizontal-separator"></div>
        <div class="main-app-name">{{ 'appName' | translate }}</div>
      </div>
      <div class="second">
        <mat-form-field class="language-field">
          <mat-select [formControl]="languageFormControl"
                      disableOptionCentering
                      panelClass="language-selection-panel"
                      disableRipple="true"
                      class="language-select">
            @for (item of availableLanguages; track item.value) {
              <mat-option [value]="item.value">{{ item.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button matButton [matMenuTriggerFor]="menu"
                (menuOpened)="onUserMenuOpen()"
                (menuClosed)="onUserMenuClose()">
          @if (user()) {
            <div> {{ user()?.firstName }} {{ user()?.lastName }}</div>
          }
          @if (userMenuOpened()) {
            <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
          } @else {
            <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
          }
        </button>
        <mat-menu #menu="matMenu" class="user-menu">
          @if (auth.isAuthenticated()) {
            <button mat-menu-item (click)="logoutUser()">
              <img src="/assets/images/logout.svg" class="logout-image" alt="">
              {{ 'logout' | translate }}
            </button>
          } @else {
            <button mat-menu-item (click)="redirectToAuthentication()">{{ 'login' | translate }}</button>
          }
        </mat-menu>
      </div>
    </div>
    <div class="app-banner">
      <div class="loaded-app-name">{{ activeAppName() }}</div>
    </div>
  </div>
}

<main class="main">
  <div class="content">
    <router-outlet />
  </div>
</main>

